module.exports = __webpack_public_path__ + "media/images/top/qa/img_step_1-668ce16f6bf18d08d4bfab1b707ebad3.png";